<block-ui></block-ui>

  <!-- Page Content -->
  <div *ngIf="ShowPageContent" class="container-fluid">
    <!-- begin::Header -->
    <div class="card card-custom-h">
      <div class="card-header border-0 pt-5">
        <div class="card-title align-items-start flex-column" *ngIf="IsFilterLoaded">
          <form [formGroup]="ActiveDirectoryForm">
            <BBSF-TextBox [options]="searchTextBox" [group]="ActiveDirectoryForm"></BBSF-TextBox>
          </form>
        </div>
        <div class="card-toolbar">
          <button type="button" class="btn btn-sm btn-primary" title='{{utilityService.getResourceValue("Add")}}' [routerLink]="['/Admin/ADConnection/Add']">
            <i class="fas fa-plus me-1"></i>
            {{utilityService.getResourceValue("Add")}}
          </button>
        </div>
      </div>
      <div class="card-body py-3">
        <!--begin::ActiveDirectory list-->
        <div class="table-responsive">
          <table class="table align-middle table-row-dashed fs-6 gy-5 dataTable no-footer">
            <thead>
              <tr class="text-start text-gray-400 fw-bolder fs-7 text-uppercase gs-0">
                <th class="min-w-150px">{{utilityService.getResourceValue("Name")}}</th>
                <th class="min-w-150px">{{utilityService.getResourceValue("Type")}}</th>
                <th class="min-w-150px">{{utilityService.getResourceValue("PermissionSet")}}</th>
                <th class="min-w-150px">{{utilityService.getResourceValue("AdConnectionRunningNow")}}</th>
                <th class="min-w-150px">{{utilityService.getResourceValue("ActiveDirectoryIdentifier")}}</th>
                <th class="min-w-50px">{{utilityService.getResourceValue("Actions")}}</th>
              </tr>
            </thead>
            <tbody id="listingContainer" class="fw-bold text-gray-600 border-0">
              <tr *ngFor="let activeDirectory of ActiveDirectoryPagingResult">

                <td class="text-dark">
                  {{activeDirectory.name}}
                </td>
                <td>
                  {{activeDirectory.adConnectionTypeName}}
                </td>
                <td>
                  {{activeDirectory.permissionSetName}}
                </td>
                <td>
                  <span class="badge badge-light-success" *ngIf="activeDirectory.isRunningNow;else not_Running">
                    {{utilityService.getResourceValue("Yes")}}
                  </span>
                  <ng-template #not_Running>
                    <span class="badge badge-light-danger">
                      {{utilityService.getResourceValue("No")}}
                    </span>
                  </ng-template>
                </td>
                <td>
                  {{activeDirectory.identifier}}
                </td>
                <td>
                  {{activeDirectory.name}}
                </td>
                <td>
                  <div>
                    <button mat-button [matMenuTriggerFor]="menu" class="btn btn-sm btn-icon btn-light btn-active-light-primary">
                      <i class="fa fa-ellipsis-h" aria-hidden="true"></i>
                    </button>
                    <mat-menu #menu="matMenu">
                      <a class="drop-item px-3" ngbDropdownItem data-toggle="modal" data-target="#editActiveDirectoryModal"
                         (click)="showEditActiveDirectoryModal(activeDirectory.id,activeDirectory.idEncrypted)">
                        <span class="drop-link px-3">{{utilityService.getResourceValue("Edit")}}</span>
                      </a>
                      <a ngbDropdownItem class="drop-item px-3" data-toggle="modal" data-target="#deleteActiveDirectoryModal"
                         (click)="showDeleteActiveDirectoryModal(activeDirectory)">
                        <span class="drop-link px-3">{{utilityService.getResourceValue("Delete")}}</span>
                      </a>
                      <a ngbDropdownItem class="drop-item px-3" data-toggle="modal" data-target="#synchronizationModal"
                         (click)="showADSynchronizationModal(activeDirectory.idEncrypted)">
                        <span class="drop-link px-3">{{utilityService.getResourceValue("ActiveDirectoryRunSyncronization")}}</span>
                      </a>
                      <a ngbDropdownItem class="drop-item px-3" data-toggle="modal" data-target="#lastRunLogsModal"
                         (click)="showADLastRunLogsModal(activeDirectory.idEncrypted)">
                        <span class="drop-link px-3">{{utilityService.getResourceValue("ActiveDirectoryLastRunLogs")}}</span>
                      </a>
                    </mat-menu>
                  </div>
                </td>
              </tr>
              <tr *ngIf="ActiveDirectoryPagingResult.length == 0">
                <td colspan="6">
                  <lib-empty-data></lib-empty-data>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!--end::Active directory list-->
      </div>
      <div class="card-footer border-0">
        <BBSF-Paging (Items)="setActiveDirectoryListResult($event)" *ngIf="IsFilterLoaded"
                     [options]="ActiveDirectoryPaging" [group]="ActiveDirectoryForm" #ActiveDirectoryPagingViewElement>
        </BBSF-Paging>
      </div>
    </div>
  </div>


  <!-- Edit Modal -->
  <div class="modal fade" id="editActiveDirectoryModal" tabindex="-1" aria-labelledby="exampleModalLabel"
       aria-hidden="true">
    <div class="modal-dialog modal-lg">
      <form [formGroup]="EditActiveDirectoryForm" *ngIf="IsEditActiveDirectoryModalLoaded" (ngSubmit)="editActiveDirectory()">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">{{utilityService.getResourceValue("Edit")}} {{utilityService.getResourceValue("ActiveDirectory")}}</h5>
            <button type="button" data-dismiss="modal" aria-label="Close" class="btn btn-icon">
              <i class="fa fa-times"></i>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-md-6">
                <BBSF-TextBox [options]="EditName" [group]="EditActiveDirectoryForm">
                </BBSF-TextBox>
              </div>
              <div class="col-md-6">
                <BBSF-DropdownList [options]="EditPermissionSetOptions" [group]="EditActiveDirectoryForm">
                </BBSF-DropdownList>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <BBSF-DropdownList [options]="EditLanguageOptions" [group]="EditActiveDirectoryForm">
                </BBSF-DropdownList>
              </div>
              <div class="col-md-6">
                <BBSF-DropdownList [options]="EditWelcomeMsgTemplateOptions" [group]="EditActiveDirectoryForm">
                </BBSF-DropdownList>
              </div>
            </div>

            <div class="row">
              <div class="col-md-6">
                <h6>
                  {{utilityService.getResourceValue("Identifier")}}
                </h6>
                <label>
                  {{EditIdentifier}}
                </label>
              </div>
              <div class="col-md-6">
                <h6>
                  {{utilityService.getResourceValue("Type")}}
                </h6>
                <label>
                  {{EditTypeName}}
                </label>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <BBSF-TextBox [options]="EditDomain" [group]="EditActiveDirectoryForm">
                </BBSF-TextBox>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <BBSF-TextBox [options]="EditSamAccount" [group]="EditActiveDirectoryForm">
                </BBSF-TextBox>
              </div>
              <div class="col-md-6">
                <BBSF-TextBox [options]="EditPassword" [group]="EditActiveDirectoryForm">
                </BBSF-TextBox>
              </div>
            </div>

            <div class="row">
              <div class="col-md-6">
                <BBSF-Toggleslide [options]="EditInactive" [group]="EditActiveDirectoryForm">
                </BBSF-Toggleslide>
              </div>
              <div class="col-md-6">
                <BBSF-Toggleslide [options]="EditDailyJob" [group]="EditActiveDirectoryForm">
                </BBSF-Toggleslide>
              </div>
            </div>
            <div class="row">
              <table class="table amsx-table-users">
                <thead>
                  <tr>
                    <th>{{utilityService.getResourceValue("Type")}}</th>
                    <th>{{utilityService.getResourceValue("Property")}}</th>
                    <th>{{utilityService.getResourceValue("ActiveDirectory_Property")}}</th>
                    <th>{{utilityService.getResourceValue("IncludeInUpdate")}}</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let option of EditMappingsOptions;let i=index;">

                    <td>
                      <BBSF-DropdownList [options]="option[0]" [group]="EditActiveDirectoryForm">
                      </BBSF-DropdownList>
                    </td>
                    <td>
                      <BBSF-DropdownList [options]="option[1]" [group]="EditActiveDirectoryForm">
                      </BBSF-DropdownList>
                    </td>
                    <td>
                      <BBSF-TextBox [options]="option[2]" [group]="EditActiveDirectoryForm">
                      </BBSF-TextBox>
                    </td>
                    <td>
                      <BBSF-CheckBox [options]="option[3]" [group]="EditActiveDirectoryForm">
                      </BBSF-CheckBox>
                    </td>

                    <td class="text-center align-middle">
                      <a class="kt-nav__link" (click)="deleteADMapping(option)">
                        <i class="kt-nav__link-icon fa fa-trash hidden" aria-hidden="true"></i>
                      </a>
                    </td>
                  </tr>
                  <tr *ngIf="EditMappingsOptions.length == 0">
                    <td colspan="5">
                      <lib-empty-data></lib-empty-data>
                    </td>
                  </tr>
                </tbody>
              </table>



              <!--<lib-provider-attributes [ProviderAttributes]="ProviderAttributes"></lib-provider-attributes>-->
            </div>



          </div>
          <div class="modal-footer">
            <button #CloseEditActiveDirectoryModal id="CloseEditActiveDirectoryModal" type="button"
                    class="btn btn-secondary" data-dismiss="modal">
              {{utilityService.getResourceValue("CancelLabel")}}
            </button>
            <button type="submit" class="btn btn-primary">{{utilityService.getResourceValue("SaveLabel")}}</button>
          </div>
        </div>
      </form>
    </div>
  </div>

  <!-- Delete  Modal -->
  <div class="modal fade" id="deleteActiveDirectoryModal" tabindex="-1" aria-labelledby="exampleModalLabel"
       aria-hidden="true">
    <div class="modal-dialog modal-lg">
      <form *ngIf="IsOpenDeleteActiveDirectoryModal">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">{{utilityService.getResourceValue("Delete")}} {{utilityService.getResourceValue("ActiveDirectory")}}</h5>

            <button type="button" data-dismiss="modal" aria-label="Close" class="btn btn-icon">
              <i class="fa fa-times"></i>
            </button>
          </div>
          <div class="modal-body">
            <div class="note note-warning text-center">
              <h3>
                {{utilityService.getResourceValue("Delete_Question")}}
              </h3>
            </div>

          </div>
          <div class="modal-footer">
            <button #CloseDeleteActiveDirectoryModal id="CloseDeleteActiveDirectoryModal" type="button"
                    class="btn btn-secondary" data-dismiss="modal">
              {{utilityService.getResourceValue("CancelLabel")}}
            </button>
            <button type="button" (click)="deleteActiveDirectory()"
                    class="btn btn-danger">
              {{utilityService.getResourceValue("Delete")}}
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>

  <!-- View Last Run Logsl -->
  <div id="lastRunLogsModal" class="modal fade example-modal-lg" aria-labelledby="exampleOptionalLarge" data-backdrop="static" role="dialog" tabindex="-1" style="display: none;" aria-hidden="true">
    <div class="modal-dialog modal-simple modal-lg">
      <div id="generateCodeParent" class="modal-content">
        <form [formGroup]="lastRunLogsForm" *ngIf="IslastRunLogsModalLoaded">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">{{utilityService.getResourceValue("ActiveDirectoryLastRunLogs")}} : {{ADConnectionName}}</h5>
              <button type="button" class="close btn btn-icon" data-dismiss="modal" aria-label="Close">
                <i class="fa fa-times"></i>
              </button>
            </div>
            <div class="modal-body">
              <!--<div class="col-md-12">
                <input type="button" value="CopyToClipboard" (click)="copyToClipboard()"  class="btn btn-success float-right" />
              </div>-->
              <div class="row">
                <div class="col-md-12">
                  <p>{{utilityService.getResourceValue("Name")}} : {{ADConnectionName}}</p>
                  <pre class="col-md-12">{{LastRunLogs}}</pre>
                </div>
              </div>

            </div>
            <div class="modal-footer">
              <button #CloseLAstRunLogsActiveDirectoryModal id="CloseLAstRunLogsActiveDirectoryModal" type="button"
                      class="btn btn-secondary" data-dismiss="modal">
                {{utilityService.getResourceValue("CancelLabel")}}
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>

  <!-- Synchronization  Modal -->
  <div class="modal fade" id="synchronizationModal" tabindex="-1" aria-labelledby="exampleModalLabel"
       aria-hidden="true">
    <div class="modal-dialog modal-lg">
      <form *ngIf="IsOpenSyncActiveDirectoryModal">
        <div class="modal-content">
          <div class="modal-header">

            <button type="button" data-dismiss="modal" aria-label="Close" class="btn btn-icon">
              <i class="fa fa-times"></i>
            </button>
          </div>
          <div class="modal-body">
            <div class="note note-warning text-center">
              <h3>
                {{utilityService.getResourceValue("SynchronizeConfirmation")}}
              </h3>
            </div>

          </div>
          <div class="modal-footer">
            <button #CloseSyncActiveDirectoryModal id="CloseSyncActiveDirectoryModal" type="button"
                    class="btn btn-secondary" data-dismiss="modal">
              {{utilityService.getResourceValue("CancelLabel")}}
            </button>
            <button type="button" (click)="runSyncronization()"
                    class="btn btn-danger">
              {{utilityService.getResourceValue("Yes")}}
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
